import { render, staticRenderFns } from "./lpj.vue?vue&type=template&id=14f522f5&scoped=true&"
import script from "./lpj.vue?vue&type=script&lang=js&"
export * from "./lpj.vue?vue&type=script&lang=js&"
import style0 from "./lpj.vue?vue&type=style&index=0&id=14f522f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f522f5",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QChip,QMenu,QList,QItem,QItemSection,QPagination,QSpace,QDialog,QFile,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QChip,QMenu,QList,QItem,QItemSection,QPagination,QSpace,QDialog,QFile,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
